import iconOrganization from './iconOrganization.svg';
import iconPortfolio from './iconPortfolio.svg';

export const icons = {
  iconOrganization,
  iconPortfolio,
};
